module.exports = __webpack_public_path__ + "img/marker-babinsa.a7b11d5b.svg";